import React, { useCallback } from 'react';

import { Container, Content, ModalContent } from './styles';

type ClassificacaoData = {
  id: number;
  id_sub: number;
  nome: string;
  status: string;
}
type ProdutoData = {
  id: string;
  categoria: string;
  cod_barras: string;
  complementos: string;
  descricao: string;
  nome: string;
  promocao: string;
  qtd: number;
  status: string;
  total: number;
  url_imagem: string;
}
interface ModalParams {
  id?: string;
  onClose: any;
  classificacao: ClassificacaoData;
  handleAtivarPausarClassif: any;
  produto: ProdutoData;
  handleAtivarPausarProduto: any;
}

const ModalPausarAtivar: React.FC<ModalParams> = ({
  id = 'ModalPausarAtivar',
  onClose = () => {},
  classificacao,
  handleAtivarPausarClassif = () => {},
  produto,
  handleAtivarPausarProduto = () => {},
}) => {
  const handleOutSideClick = useCallback(
    (e: any) => {
      if (e.target.id === id) {
        onClose();
      }
    },
    [id, onClose],
  );

  const handleAtivaDesativa = useCallback(() => {
    if (classificacao.id) {
      classificacao.status = classificacao.status === 'S' ? 'N' : 'S';
      handleAtivarPausarClassif(classificacao.status, classificacao);
    } else if (produto.id) {
      produto.status = produto.status === 'S' ? 'N' : 'S';
      handleAtivarPausarProduto(produto.status, produto.id);
    }

    onClose();
  }, [
    classificacao,
    handleAtivarPausarClassif,
    produto,
    handleAtivarPausarProduto,
    onClose,
  ]);

  return (
    <Container id="ModalPausarAtivar" onClick={handleOutSideClick}>
      <Content>
        <ModalContent>
          <div className="modal-message">
            {produto.id && (
              <h2>
                Deseja mesmo {produto.status === 'S' ? 'PAUSAR' : 'ATIVAR'} este
                Produto <br /> {'"'} {produto.nome} {'"'}
              </h2>
            )}

            {classificacao.id && (
              <h2>
                Deseja mesmo{' '}
                {classificacao.status === 'S' ? 'PAUSAR' : 'ATIVAR'} esta
                Classificação <br /> {'"'} {classificacao.nome} {'"'}
              </h2>
            )}
          </div>

          <div className="modal-buttons">
            <button className="btn-cancel" onClick={onClose}>
              Cancelar
            </button>

            {classificacao.id && (
              <button
                className={
                  classificacao.status === 'S' ? 'btn-pausar' : 'btn-ativar'
                }
                onClick={handleAtivaDesativa}
              >
                {classificacao.status === 'S' ? 'PAUSAR' : 'ATIVAR'}
              </button>
            )}

            {produto.id && (
              <button
                className={produto.status === 'S' ? 'btn-pausar' : 'btn-ativar'}
                onClick={handleAtivaDesativa}
              >
                {produto.status === 'S' ? 'PAUSAR' : 'ATIVAR'}
              </button>
            )}
          </div>
        </ModalContent>
      </Content>
    </Container>
  );
};

export default ModalPausarAtivar;
